<template>
  <div class="main-content">

    <SideBarModal
      v-if="modalOpen"
      :user="selectedUser"
      :roles="roles"
      :tags="usersTags"
      :onModalClose="() => this.modalOpen = false"
    />

    <div class="card">
      <div class="card-header"></div>
      <div class="card-body">

        <tabs v-if="!loading && originalUsers.length">
          <tab title="Курьеры">
            <RunnersList
              :users="runnersData.users"
              :unlinkedUsers="runnersData.unlinkedUsers"
              :inactiveUsers="runnersData.inactiveUsers"
              :editUser="openSideModal"
            />
          </tab>
          <tab title="Агенты">
            <UsersList
              :users="users.agentDivision"
              :editUser="openSideModal"
            />
          </tab>
          <tab title="Продажники">
            <ManagersList
              :users="users.managers"
              :assists="users.managerAssist || []"
              :editUser="openSideModal"
            />
          </tab>
          <tab title="Прочие сотрудники">
            <UsersList
              :users="users.others"
              :editUser="openSideModal"
            />
          </tab>
        </tabs>

        <div v-if="loading">
          <pulse-loader :loading="true" :color="$constants.LOADING_COLOR" class="text-center"/>
        </div>
        <div v-if="false">

          <!--          <div class="form-group">-->
          <!--            <div class="form-check">-->
          <!--              <input @change="updateUsersList" v-model="filter.showRunners" class="form-check-input" type="checkbox" id="gridCheck">-->
          <!--              <label class="form-check-label" for="gridCheck">-->
          <!--                Показать курьеров-->
          <!--              </label>-->
          <!--            </div>-->
          <!--          </div>-->

          <table v-if="users" class="table table-sm table-hover table-striped">
            <thead>
            <tr>
              <th></th>
              <th>ФИО</th>
              <th>Логин</th>
              <th>Email</th>
              <th>Телефон</th>
              <th>Должность</th>
              <th>Комментарий</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(user, index) in users" :key="user.id">
              <td>{{ index + 1 }}</td>
              <td>{{ user.name }}</td>
              <td>{{ user.login }}</td>
              <td>{{ user.email }}</td>
              <td>{{ user.phone }}</td>
              <td>
                <div v-html="printRoles(user)"/>
              </td>
              <td></td>
              <td>
                <button
                  @click="openSideModal(user)"
                  class="btn btn-xs btn-info newWindowBtn mr-1"
                >
                  <i class="icon-fa icon-fa-eye"></i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import SideBarModal from "@/components/modals/users/SideBarModal";
import {Tabs, Tab} from 'vue-slim-tabs'
import ManagersList from './components/ManagersList';
import UsersList from './components/UsersList';
import RunnersList from './components/RunnersList';

export default {
  components: {
    SideBarModal,
    Tabs,
    Tab,
    ManagersList,
    UsersList,
    RunnersList,
  },
  data() {
    return {
      modalOpen: false,
      loading: false,
      users: {},
      roles: null,
      usersTags: null,
      runnersData: {},
      originalUsers: [],
      shifts: [],
      filter: {
        showRunners: false
      },
      selectedUser: null
    }
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    printRoles(user) {
      let text = '';
      if (user.roles) {
        user.roles.forEach((r) => {
          text += `<p class="mb-0">${r.name_title}</p>`;
        })
      }
      return text;
    },
    async getUsers() {
      this.loading = true;
      const {data} = await api.index('users/list');
      if (data.success) {
        this.runnersData = data.runnersData;
        this.roles = data.roles;
        this.usersTags = data.tags;
        this.originalUsers = data.users;
        this.updateUsersList();
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.loading = false;
    },
    updateUsersList() {
      let users = [...this.originalUsers];

      const filteredUsers = {};
      users.forEach((user) => {
        let filtered = false;
        user.roles.forEach((role) => {
          switch (role.name) {
            case 'runner':
            case 'chiefRunner':
            case 'postChiefRunner':
              filtered = true;
              break;
            case 'manager':
            case 'codManager':
              if (!filteredUsers.managers) filteredUsers.managers = {};
              filteredUsers.managers[user.id] = user;
              filtered = true;
              break;
            case 'managerAssist':
            case 'agentDivision':
            case 'agentReSeller':
              let roleName = role.name;
              if (role.name === 'agentReSeller') {
                roleName = 'agentDivision';
              }
              if (!filteredUsers[roleName]) filteredUsers[roleName] = {};
              filteredUsers[roleName][user.id] = user;
              filtered = true;
              break;
          }
        });
        if (!filtered) {
          if (!filteredUsers.others) filteredUsers.others = [];
          filteredUsers.others.push(user);
        }
      });

      this.users = filteredUsers;
      return;

      Object.keys(this.filter).forEach((filterTitle) => {
        users = users.filter((u) => {
          switch (filterTitle) {
            case 'showRunners':
              if (!this.filter[filterTitle]) {
                return !u.roles.find((r) => r.name === 'runner')
              } else {
                return true
              }
            default:
              return true;
          }
        })
      })
      this.users = users;
    },
    openSideModal(user) {
      this.selectedUser = user;
      this.modalOpen = true;
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 2px;
}
</style>

<style src="vue-slim-tabs/themes/default.css"></style>
